import { useState } from "react";
import CustomTabs from "shared/components/common/customTabs";
import classNames from "classnames";
import styles from "./style.module.scss";
import UpdateProfile from "../../../shared/components/dashboard/updateProfile";
import ChangePassword from "../../../shared/components/dashboard/changePassword";

const DashboardSettings = () => {
  const [activeTab, setActiveTab] = useState<string>("updateProfile");

  const tabs = [
    { label: "Update Profile", value: "updateProfile" },
    { label: "Change Password", value: "changePassword" },
  ];

  const handleTabChange = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  return (
    <>
      <div className={classNames(styles.sectionContainer)}>
        <div>
          <CustomTabs
            tabs={tabs}
            // fullWidthTabs
            defaultActiveTab="updateProfile"
            onTabChange={handleTabChange}
          />
        </div>
      </div>
      <div className={classNames(styles.sectionContainer, "mt-4")}>
        <div>
          {activeTab === "updateProfile" ? (
            <UpdateProfile />
          ) : (
            <ChangePassword />
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardSettings;
